/*
 *
 * Subscription reducer
 *
 */

import { fromJS } from 'immutable';
import * as constants from './constants';

const initialState = {
  subscriptionAccountList: undefined,
  subscriptionTeamList: undefined,
};

function subscriptionReducer(state = fromJS(initialState), action) {
  switch (action.type) {
    case constants.SET_SUBSCRIPTION_ACCOUNT_LIST:
      return state
        .set('subscriptionAccountList', action.accounts);
    case constants.SET_SUBSCRIPTION_TEAM_LIST:
      return state
        .set('subscriptionTeamList', action.teams);
    default:
      return state;
  }
}

export {
  initialState,
};

export default subscriptionReducer;
